import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=f89248dc&scoped=true&lang=pug"
import script from "./TemplateList.vue?vue&type=script&lang=ts"
export * from "./TemplateList.vue?vue&type=script&lang=ts"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=f89248dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89248dc",
  null
  
)

export default component.exports